import type { MappedProduct, SearchResultV2 } from '@ab-core/graphql/dist';

const searchV2ProductsMapper = (products?: Array<MappedProduct>): Array<MappedProduct> | undefined => {
    return products?.map((product) => {
        return {
            ...product,
            image: product.image
        };
    });
};

export const searchV2DataMapper = (data: SearchResultV2): SearchResultV2 => {
    return { ...data, results: searchV2ProductsMapper(data.results) };
};
